import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./List.scss";

const List = ({ iconName, listItems }) => (
  <ul className="fa-ul">
    {listItems.map((text) => (
      <li>
        <FontAwesomeIcon icon={iconName} className="list-icon" />
        {text}
      </li>
    ))}
  </ul>
);

export default List;
